<div class="@container" data-test-id="usp-bar">
	<div class="flex flex-wrap @lg:flex-nowrap">
		@for (usp of usps(); track usp) {
			<div
				class="w-full p-2 @sm:basis-1/2 @md:basis-1/3 @lg:flex-1 @lg:basis-0"
				data-test-class="usp"
			>
				@if (usp.link) {
					<a
						[href]="usp.link"
						[target]="usp.target ?? '_self'"
						(click)="onClick($event, usp)"
						class="flex gap-4 no-underline outline-black @lg:flex-col @lg:gap-2"
						rel="noopener noreferrer"
					>
						<ng-container
							[ngTemplateOutlet]="uspTemplate"
							[ngTemplateOutletContext]="{ usp, rating: false }"
						/>
					</a>
				} @else {
					<div class="flex gap-4 @lg:flex-col @lg:gap-2">
						<ng-container
							[ngTemplateOutlet]="uspTemplate"
							[ngTemplateOutletContext]="{ usp, rating: false }"
						/>
					</div>
				}
			</div>
		}
		@if (rating()?.score && rating()?.numberOfRatings) {
			<div
				class="w-full p-2 @sm:basis-1/2 @md:basis-1/3 @lg:flex-1 @lg:basis-0"
				data-test-class="usp"
			>
				<div class="flex gap-4 @lg:flex-col @lg:gap-2">
					<ng-container
						[ngTemplateOutlet]="uspTemplate"
						[ngTemplateOutletContext]="{
							usp: {
								description: 'components.usp-bar.reviews',
								icon: rating()?.score,
								link: null,
								title:
									'components.usp-bar.ratings.' + ratingKey(),
							},
							rating: rating(),
						}"
					/>
				</div>
			</div>
		}
	</div>
</div>

<ng-template #uspTemplate let-rating="rating" let-usp="usp">
	@if (!rating) {
		<svg-icon
			[attr.data-test-id]="usp.icon"
			[ngClass]="
				cn(
					iconVariantClass(),
					iconTypeClass(),
					iconType() !== 'shaded' &&
						iconType() !== 'solid' &&
						'icon-container-md-full @sm:icon-container-lg-full'
				)
			"
			[src]="usp.icon"
			class="icon-container shrink-0 @sm:icon-container-lg @lg:self-center"
		/>
	} @else {
		<vp-rating-svg
			[ngClass]="
				cn(
					iconVariantClass(),
					iconTypeClass(),
					iconType() !== 'shaded' &&
						iconType() !== 'solid' &&
						'icon-container-md-full @sm:icon-container-lg-full'
				)
			"
			[score]="usp.icon"
			class="icon-container shrink-0 @sm:icon-container-lg @lg:self-center"
		/>
	}
	<div class="flex items-center @lg:text-center">
		<div class="w-full">
			<span
				[ngClass]="
					cn(
						iconVariant() === 'default' && 'text-dark-tertiary',
						iconVariant() !== 'default' && 'text-dark-primary'
					)
				"
				class="block font-sans-serif text-sm font-semibold @lg:text-base"
				data-test-id="usp-bar-title"
			>
				{{ usp.title | translate }}
			</span>
			<span
				[ngClass]="
					cn(
						iconVariant() === 'default' && 'text-dark-tertiary',
						iconVariant() !== 'default' && 'text-dark-primary'
					)
				"
				class="block font-sans-serif text-sm"
				data-test-id="usp-bar-description"
			>
				{{
					usp.description
						| translate: { numberOfRatings: rating.numberOfRatings }
				}}
			</span>
		</div>
	</div>
	@if (usp.link) {
		<svg-icon
			[attr.data-test-id]="'usp-chevron'"
			class="icon-container icon-container-sm ml-auto self-center @lg:hidden"
			src="assets/icons/icon-chevron-right.svg"
		/>
	}
</ng-template>
